function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#garbage-bin-2_svg__clip0)",
  fill: "#879097"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.73 5.284l-.436-1.307a.645.645 0 00-.611-.44H4.314a.645.645 0 00-.611.44l-.436 1.307a.457.457 0 00.434.602h12.595a.457.457 0 00.434-.602zM5.297 19.21c.05.45.43.79.883.79h7.567c.453 0 .833-.34.883-.79L15.98 7.06H3.947l1.35 12.151zM8.823 1.68c0-.28.228-.508.508-.508h1.726c.28 0 .508.228.508.508v.684h1.172V1.68c0-.927-.754-1.68-1.68-1.68H9.331c-.926 0-1.68.753-1.68 1.68v.684h1.172V1.68z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "garbage-bin-2_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgGarbageBin2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgGarbageBin2;